import {
  ApplicationConfig,
  inject,
  provideAppInitializer, provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, withDebugTracing} from '@angular/router';

import {routes} from './app.routes';
import {environment} from '../environments/environment';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeng/themes/aura';
import {authInterceptorProviders} from '../services/auth.interceptor';
import {TranslationService} from '../services/translation.service';
import {downloadIndicatorInterceptorProviders} from '../services/download-indicator-interceptor';
import {DialogService} from 'primeng/dynamicdialog';
import {MessageService} from 'primeng/api';
import {API_BASE_URL} from '../api/api-client';
import {PictureAnnotationWidgetService} from '../services/picture-annotation-widget.service';
import {HttpErrorInterceptor} from '../services/http-error-interceptor';
import {SubscriptionManager} from '../services/subscription-manager.service';


export function initializeTranslations(
  transService: TranslationService
) {
  return transService.getTranslationsForLanguage(navigator.language);
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng'
          },
          darkModeSelector: '.dark'
        }
      },
      ripple: true,
      translation: {
        dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
        dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
        dateFormat: "dd.mm.yy",
        firstDayOfWeek: 1,
      }
    }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {provide: API_BASE_URL, useValue: environment.API_BASE_URL},
    authInterceptorProviders,
    downloadIndicatorInterceptorProviders,
    provideAppInitializer(() => initializeTranslations(inject(TranslationService))),
    DialogService,
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    PictureAnnotationWidgetService,
    SubscriptionManager
  ]
};

